































































// decoradores
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { TipoCargo } from "@/typings/store/plugins/easyFirestore/tipoCargos";
import SVGIcon from "@/components/SVGIcon.vue";
// tipos

// tipos
@Component({
  components: {
    SVGIcon,
  },
})
export default class InfoTipoCargo extends Vue {
  @Prop() readonly tipoCargo!: TipoCargo;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.tipoCargo.id || "N/R";
  }

  get nombre(): string {
    return this.tipoCargo.nombre || "N/R";
  }

  get idTipo(): string {
    return this.tipoCargo.idTipo || "N/R";
  }


  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
